import '@lottiefiles/lottie-player';

function setupLottieHover(playerSelector) {
  const players = document.querySelectorAll(playerSelector);

  // Store the reduced motion preference
  let reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches;

  // Helper function to play the animation
  function playAnimation(player, loop) {
    if (reduceMotion) {
      player.pause();
      return;
    }
    player.loop = loop;
    player.play();
  }

  // Helper function to pause the animation
  function pauseAnimation(player) {
    if (reduceMotion) {
      player.pause();
      return;
    }
    player.pause();
  }

  players.forEach((player) => {
    const container = player.parentElement;
    player.setAttribute('loop', true);
    const input = container.querySelector('input');

    if (container && input) {
      // Play animation on hover or focus
      container.addEventListener('mouseover', () => {
        playAnimation(player, playConfig.loopOnInteraction);
      });

      input.addEventListener('focus', () => {
        playAnimation(player, playConfig.loopOnInteraction);
      });

      // Pause animation on mouse leave or blur
      container.addEventListener('mouseleave', () => {
        pauseAnimation(player);
      });

      input.addEventListener('blur', () => {
        pauseAnimation(player);
      });
    }
  });

  // Listen for changes in the 'prefers-reduced-motion' setting
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  mediaQuery.addEventListener('change', (e) => {
    reduceMotion = e.matches;
  });
}

// Applying the interaction setup
setupLottieHover('lottie-player', {
  loopOnInteraction: true,
});
